import { TaskImportance } from "../enums/task-importance.enum";

export const getImportanceContainerColor = (importance: string) => {
  switch (importance) {
    case TaskImportance.VERY_IMPORTANT:
      return "#f44336"; // red
    case TaskImportance.IMPORTANT:
      return "#ff9800"; // orange
    case TaskImportance.NOT_IMPORTANT:
      return "#4caf50"; // green
    default:
      return "#9e9e9e"; // grey
  }
};

export const getImportanceContainerText = (importance: TaskImportance) => {
  switch (importance) {
    case TaskImportance.VERY_IMPORTANT:
      return "Very Important";
    case TaskImportance.IMPORTANT:
      return "Important";
    case TaskImportance.NOT_IMPORTANT:
      return "Not important";
    default:
      return "Unknown";
  }
};
